// Handles mixing in properties to vuex-orm models.
// Currently supports:
// - mutators
// - fields
// - getters/setters
// - plain functions

function extractFields(method) {
  // The `replace()` call removes comments.
  const methodString = method.toString().replace(/\/\/.*$/gm, '');

  const methodBodyString = methodString
    .slice(methodString.indexOf('{') + 1, methodString.lastIndexOf('}'))
    .trim();

  return methodBodyString
    .slice(methodBodyString.indexOf('{') + 1, methodBodyString.lastIndexOf('}'))
    .trim();
}

export default function (object, mixin) {
  if (mixin.mutators) {
    let prevMutators = object.mutators();
    object.mutators = () => {
      return {
        ...prevMutators,
        ...mixin.mutators(),
      };
    };
  }

  if (mixin.fields) {
    // NOTE: We need to use an unbound reference to fields because calling
    // `toString()` on a bound function may not yield the original source.
    // See https://stackoverflow.com/a/40451866/659910
    const newFunction = new Function(
      `return {
        ${extractFields(object._fieldsUnbound || object.fields)},
        ${extractFields(mixin.fields)}
      }`
    );

    object._fieldsUnbound = newFunction;
    object.fields = newFunction.bind(object);
  }

  Object.entries(Object.getOwnPropertyDescriptors(mixin))
    .filter(
      (pair) =>
        typeof pair[1].get === 'function' ||
        typeof pair[1].set === 'function' ||
        // Allows plain functions to get mixed in.
        // TODO: Make sure this excludes library functions like `mutators`.
        typeof pair[1].value === 'function'
    )
    .forEach(([name, config]) => {
      Object.defineProperty(object.prototype, name, config);
    });
}
